import React, { useEffect, useState } from "react";
import {
  Box,
  Paper,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from "@mui/material";
import { apiCallUserSearchHistory } from "../../../../Core/Apicall";
import { useLocation } from "react-router-dom";
import CommonPagination from "../../../Common/CommonPagination/CommonPagination";
import CommonShimmer from "../../../Common/CommonShimmer/CommonShimmer";
import EmptyData from "../../../Common/EmptyData/EmptyData";
import moment from "moment";

const SearchHistory: React.FC = () => {
  const [tableData, setTableData] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const [totalItems, setTotalItems] = useState(0);
  const totalPages = Math.ceil(totalItems / rowsPerPage);

  const location = useLocation();
  const useData = location.state.user;

  const handleApiCall = async (userId: any) => {
    setLoading(true);
    try {
      const data = {
        userId,
        offset: page,
        limit: rowsPerPage,
      };
      const res = await apiCallUserSearchHistory(data);

      setTableData(res.data || []);
      setTotalItems(res?.totalCount || 0);
    } catch (err) {
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    handleApiCall(useData.userId ? useData.userId : useData._id);
  }, [page, rowsPerPage, useData]);

  const handlePageChange = (value: number) => {
    setPage(value);
  };

  return (
    <Box sx={{}}>
      <Paper
        className="scroll-bar"
        sx={{
          borderRadius: 3,
          overflow: "hidden",
          position: "relative",
        }}
      >
        <TableContainer className="scroll-bar">
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell>Type</TableCell>
                <TableCell>Search Text</TableCell>
                <TableCell>Filters</TableCell>
                <TableCell>Date</TableCell>
              </TableRow>
            </TableHead>

            {loading === false && (
              <TableBody>
                {tableData.map((item: any) => (
                  <TableRow key={item._id}>
                    <TableCell>{item.type || "-"}</TableCell>
                    <TableCell>{item.searchText || "-"}</TableCell>
                    <TableCell>
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          gap: "6px",
                        }}
                      >
                        {item.filters?.direction?.length > 0 && (
                          <Box>
                            <b>Direction:</b>{" "}
                            {item.filters.direction.map(
                              (d: string, i: number) => (
                                <span
                                  key={i}
                                  style={{
                                    padding: "3px 8px",
                                    background: "#e0e0e0",
                                    marginRight: "5px",
                                    borderRadius: "6px",
                                    fontSize: "12px",
                                  }}
                                >
                                  {d}
                                </span>
                              ),
                            )}
                          </Box>
                        )}
                        {item.filters?.daysIds?.length > 0 && (
                          <Box>
                            <b>Days:</b>{" "}
                            {item.filters.daysIds.map((d: any, i: number) => (
                              <span
                                key={i}
                                style={{
                                  padding: "3px 8px",
                                  background: "#e0e0e0",
                                  marginRight: "5px",
                                  borderRadius: "6px",
                                  fontSize: "12px",
                                }}
                              >
                                {d.name}
                              </span>
                            ))}
                          </Box>
                        )}
                        {item.filters?.dinningIds?.length > 0 && (
                          <Box>
                            <b>Dinning:</b>{" "}
                            {item.filters.dinningIds.map(
                              (d: any, i: number) => (
                                <span
                                  key={i}
                                  style={{
                                    padding: "3px 8px",
                                    background: "#e0e0e0",
                                    marginRight: "5px",
                                    borderRadius: "6px",
                                    fontSize: "12px",
                                  }}
                                >
                                  {d.name}
                                </span>
                              ),
                            )}
                          </Box>
                        )}
                        {item.filters?.drinkIds?.length > 0 && (
                          <Box>
                            <b>Drinks:</b>{" "}
                            {item.filters.drinkIds.map((d: any, i: number) => (
                              <span
                                key={i}
                                style={{
                                  padding: "3px 8px",
                                  background: "#e0e0e0",
                                  marginRight: "5px",
                                  borderRadius: "6px",
                                  fontSize: "12px",
                                }}
                              >
                                {d.name}
                              </span>
                            ))}
                          </Box>
                        )}
                        {item.filters?.musicIds?.length > 0 && (
                          <Box>
                            <b>Music:</b>{" "}
                            {item.filters.musicIds.map((d: any, i: number) => (
                              <span
                                key={i}
                                style={{
                                  padding: "3px 8px",
                                  background: "#e0e0e0",
                                  marginRight: "5px",
                                  borderRadius: "6px",
                                  fontSize: "12px",
                                }}
                              >
                                {d.name}
                              </span>
                            ))}
                          </Box>
                        )}

                        {item.filters?.eventTypeId?.length > 0 && (
                          <Box>
                            <b>Event Type:</b>{" "}
                            {item.filters.eventTypeId.map(
                              (d: any, i: number) => (
                                <span
                                  key={i}
                                  style={{
                                    padding: "3px 8px",
                                    background: "#e0e0e0",
                                    marginRight: "5px",
                                    borderRadius: "6px",
                                    fontSize: "12px",
                                  }}
                                >
                                  {d.name}
                                </span>
                              ),
                            )}
                          </Box>
                        )}
                        {item.filters?.publicProfileIds?.length > 0 && (
                          <Box>
                            <b>Public Profile:</b>{" "}
                            {item.filters.publicProfileIds.map(
                              (d: any, i: number) => (
                                <span
                                  key={i}
                                  style={{
                                    padding: "3px 8px",
                                    background: "#e0e0e0",
                                    marginRight: "5px",
                                    borderRadius: "6px",
                                    fontSize: "12px",
                                  }}
                                >
                                  {d.name}
                                </span>
                              ),
                            )}
                          </Box>
                        )}

                        {item.filters?.genderArray?.length > 0 && (
                          <Box>
                            <b>Gender:</b>{" "}
                            {item.filters.genderArray.map(
                              (d: any, i: number) => (
                                <span
                                  key={i}
                                  style={{
                                    padding: "3px 8px",
                                    background: "#e0e0e0",
                                    marginRight: "5px",
                                    borderRadius: "6px",
                                    fontSize: "12px",
                                  }}
                                >
                                  {d}
                                </span>
                              ),
                            )}
                          </Box>
                        )}

                        {item.filters?.relationArray?.length > 0 && (
                          <Box>
                            <b>RelationShip:</b>{" "}
                            {item.filters.relationArray.map(
                              (d: any, i: number) => (
                                <span
                                  key={i}
                                  style={{
                                    padding: "3px 8px",
                                    background: "#e0e0e0",
                                    marginRight: "5px",
                                    borderRadius: "6px",
                                    fontSize: "12px",
                                  }}
                                >
                                  {d}
                                </span>
                              ),
                            )}
                          </Box>
                        )}

                        {item.filters?.ageArray?.length > 0 && (
                          <Box>
                            <b>Age Group:</b>{" "}
                            {item.filters.ageArray.map((d: any, i: number) => (
                              <span
                                key={i}
                                style={{
                                  padding: "3px 8px",
                                  background: "#e0e0e0",
                                  marginRight: "5px",
                                  borderRadius: "6px",
                                  fontSize: "12px",
                                }}
                              >
                                {d.min}-{d.max}
                              </span>
                            ))}
                          </Box>
                        )}

                        {(!item.filters ||
                          Object.values(item.filters).every(
                            (v: any) => !v || v.length === 0,
                          )) &&
                          "-"}
                      </Box>
                    </TableCell>
                    <TableCell>
                      {item.createdAt
                        ? moment(item.createdAt).format("DD-MMM-YYYY, hh:mm A")
                        : "-"}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            )}
          </Table>

          {loading === true && (
            <div style={{ padding: "10px 10px" }}>
              <CommonShimmer />
            </div>
          )}

          {loading === false && <EmptyData data={tableData} />}
        </TableContainer>

        <CommonPagination
          page={page}
          rowsPerPage={rowsPerPage}
          totalItems={totalItems}
          totalPages={totalPages}
          onPageChange={(value) => handlePageChange(value)}
          onRowsPerPageChange={(value) => {
            setRowsPerPage(value);
            setPage(1);
          }}
        />
      </Paper>
    </Box>
  );
};

export default SearchHistory;
